/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PaymentRouteImport } from './routes/payment'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardRouteImport } from './routes/_dashboard'
import { Route as DashboardIndexRouteImport } from './routes/_dashboard/index'
import { Route as DashboardSearchIndexRouteImport } from './routes/_dashboard/search/index'
import { Route as DashboardPortoutRequestsIndexRouteImport } from './routes/_dashboard/portout-requests/index'
import { Route as DashboardOwnershipTransferIndexRouteImport } from './routes/_dashboard/ownership-transfer/index'
import { Route as DashboardDeliveryRequestsIndexRouteImport } from './routes/_dashboard/delivery-requests/index'
import { Route as DashboardContinuousPaymentPortoutRequestsIndexRouteImport } from './routes/_dashboard/continuous-payment-portout-requests/index'
import { Route as DashboardContinuousPaymentConfirmationIndexRouteImport } from './routes/_dashboard/continuous-payment-confirmation/index'
import { Route as DashboardClientsIndexRouteImport } from './routes/_dashboard/clients/index'
import { Route as DashboardCallDetailsIndexRouteImport } from './routes/_dashboard/call-details/index'
import { Route as DashboardBlacklistingRequestsIndexRouteImport } from './routes/_dashboard/blacklisting-requests/index'
import { Route as DashboardBillingIndexRouteImport } from './routes/_dashboard/billing/index'
import { Route as DashboardBillingManagementIndexRouteImport } from './routes/_dashboard/billing-management/index'
import { Route as PaymentCardRegisterTokenRouteImport } from './routes/payment/card-register/$token'
import { Route as DashboardPortoutRequestsNewRouteImport } from './routes/_dashboard/portout-requests/new'
import { Route as DashboardPortoutRequestsCancelRouteImport } from './routes/_dashboard/portout-requests/cancel'
import { Route as DashboardDeliveryRequestsCreateRouteImport } from './routes/_dashboard/delivery-requests/create'
import { Route as DashboardContinuousPaymentPortoutRequestsNewRouteImport } from './routes/_dashboard/continuous-payment-portout-requests/new'
import { Route as DashboardContinuousPaymentPortoutRequestsCancelRouteImport } from './routes/_dashboard/continuous-payment-portout-requests/cancel'
import { Route as DashboardClientsCreateRouteImport } from './routes/_dashboard/clients/create'
import { Route as DashboardBlacklistingRequestsNewRouteImport } from './routes/_dashboard/blacklisting-requests/new'
import { Route as DashboardClientsClientIdIndexRouteImport } from './routes/_dashboard/clients/$clientId/index'
import { Route as DashboardDeliveryRequestsIdShippingHistoryRouteImport } from './routes/_dashboard/delivery-requests/$id.shipping-history'
import { Route as DashboardClientsClientIdSimBindingRouteImport } from './routes/_dashboard/clients/$clientId/sim-binding'
import { Route as DashboardClientsClientIdInvoicesIndexRouteImport } from './routes/_dashboard/clients/$clientId/invoices/index'
import { Route as DashboardClientsClientIdInvoicesInvoiceIdRouteImport } from './routes/_dashboard/clients/$clientId/invoices/$invoiceId'

const PaymentRoute = PaymentRouteImport.update({
  id: '/payment',
  path: '/payment',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSearchIndexRoute = DashboardSearchIndexRouteImport.update({
  id: '/search/',
  path: '/search/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardPortoutRequestsIndexRoute =
  DashboardPortoutRequestsIndexRouteImport.update({
    id: '/portout-requests/',
    path: '/portout-requests/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardOwnershipTransferIndexRoute =
  DashboardOwnershipTransferIndexRouteImport.update({
    id: '/ownership-transfer/',
    path: '/ownership-transfer/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDeliveryRequestsIndexRoute =
  DashboardDeliveryRequestsIndexRouteImport.update({
    id: '/delivery-requests/',
    path: '/delivery-requests/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardContinuousPaymentPortoutRequestsIndexRoute =
  DashboardContinuousPaymentPortoutRequestsIndexRouteImport.update({
    id: '/continuous-payment-portout-requests/',
    path: '/continuous-payment-portout-requests/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardContinuousPaymentConfirmationIndexRoute =
  DashboardContinuousPaymentConfirmationIndexRouteImport.update({
    id: '/continuous-payment-confirmation/',
    path: '/continuous-payment-confirmation/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardClientsIndexRoute = DashboardClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCallDetailsIndexRoute =
  DashboardCallDetailsIndexRouteImport.update({
    id: '/call-details/',
    path: '/call-details/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardBlacklistingRequestsIndexRoute =
  DashboardBlacklistingRequestsIndexRouteImport.update({
    id: '/blacklisting-requests/',
    path: '/blacklisting-requests/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardBillingIndexRoute = DashboardBillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardBillingManagementIndexRoute =
  DashboardBillingManagementIndexRouteImport.update({
    id: '/billing-management/',
    path: '/billing-management/',
    getParentRoute: () => DashboardRoute,
  } as any)
const PaymentCardRegisterTokenRoute =
  PaymentCardRegisterTokenRouteImport.update({
    id: '/card-register/$token',
    path: '/card-register/$token',
    getParentRoute: () => PaymentRoute,
  } as any)
const DashboardPortoutRequestsNewRoute =
  DashboardPortoutRequestsNewRouteImport.update({
    id: '/portout-requests/new',
    path: '/portout-requests/new',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardPortoutRequestsCancelRoute =
  DashboardPortoutRequestsCancelRouteImport.update({
    id: '/portout-requests/cancel',
    path: '/portout-requests/cancel',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDeliveryRequestsCreateRoute =
  DashboardDeliveryRequestsCreateRouteImport.update({
    id: '/delivery-requests/create',
    path: '/delivery-requests/create',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardContinuousPaymentPortoutRequestsNewRoute =
  DashboardContinuousPaymentPortoutRequestsNewRouteImport.update({
    id: '/continuous-payment-portout-requests/new',
    path: '/continuous-payment-portout-requests/new',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardContinuousPaymentPortoutRequestsCancelRoute =
  DashboardContinuousPaymentPortoutRequestsCancelRouteImport.update({
    id: '/continuous-payment-portout-requests/cancel',
    path: '/continuous-payment-portout-requests/cancel',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardClientsCreateRoute = DashboardClientsCreateRouteImport.update({
  id: '/clients/create',
  path: '/clients/create',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardBlacklistingRequestsNewRoute =
  DashboardBlacklistingRequestsNewRouteImport.update({
    id: '/blacklisting-requests/new',
    path: '/blacklisting-requests/new',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardClientsClientIdIndexRoute =
  DashboardClientsClientIdIndexRouteImport.update({
    id: '/clients/$clientId/',
    path: '/clients/$clientId/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDeliveryRequestsIdShippingHistoryRoute =
  DashboardDeliveryRequestsIdShippingHistoryRouteImport.update({
    id: '/delivery-requests/$id/shipping-history',
    path: '/delivery-requests/$id/shipping-history',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardClientsClientIdSimBindingRoute =
  DashboardClientsClientIdSimBindingRouteImport.update({
    id: '/clients/$clientId/sim-binding',
    path: '/clients/$clientId/sim-binding',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardClientsClientIdInvoicesIndexRoute =
  DashboardClientsClientIdInvoicesIndexRouteImport.update({
    id: '/clients/$clientId/invoices/',
    path: '/clients/$clientId/invoices/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardClientsClientIdInvoicesInvoiceIdRoute =
  DashboardClientsClientIdInvoicesInvoiceIdRouteImport.update({
    id: '/clients/$clientId/invoices/$invoiceId',
    path: '/clients/$clientId/invoices/$invoiceId',
    getParentRoute: () => DashboardRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/login': typeof LoginRoute
  '/payment': typeof PaymentRouteWithChildren
  '/': typeof DashboardIndexRoute
  '/blacklisting-requests/new': typeof DashboardBlacklistingRequestsNewRoute
  '/clients/create': typeof DashboardClientsCreateRoute
  '/continuous-payment-portout-requests/cancel': typeof DashboardContinuousPaymentPortoutRequestsCancelRoute
  '/continuous-payment-portout-requests/new': typeof DashboardContinuousPaymentPortoutRequestsNewRoute
  '/delivery-requests/create': typeof DashboardDeliveryRequestsCreateRoute
  '/portout-requests/cancel': typeof DashboardPortoutRequestsCancelRoute
  '/portout-requests/new': typeof DashboardPortoutRequestsNewRoute
  '/payment/card-register/$token': typeof PaymentCardRegisterTokenRoute
  '/billing-management': typeof DashboardBillingManagementIndexRoute
  '/billing': typeof DashboardBillingIndexRoute
  '/blacklisting-requests': typeof DashboardBlacklistingRequestsIndexRoute
  '/call-details': typeof DashboardCallDetailsIndexRoute
  '/clients': typeof DashboardClientsIndexRoute
  '/continuous-payment-confirmation': typeof DashboardContinuousPaymentConfirmationIndexRoute
  '/continuous-payment-portout-requests': typeof DashboardContinuousPaymentPortoutRequestsIndexRoute
  '/delivery-requests': typeof DashboardDeliveryRequestsIndexRoute
  '/ownership-transfer': typeof DashboardOwnershipTransferIndexRoute
  '/portout-requests': typeof DashboardPortoutRequestsIndexRoute
  '/search': typeof DashboardSearchIndexRoute
  '/clients/$clientId/sim-binding': typeof DashboardClientsClientIdSimBindingRoute
  '/delivery-requests/$id/shipping-history': typeof DashboardDeliveryRequestsIdShippingHistoryRoute
  '/clients/$clientId': typeof DashboardClientsClientIdIndexRoute
  '/clients/$clientId/invoices/$invoiceId': typeof DashboardClientsClientIdInvoicesInvoiceIdRoute
  '/clients/$clientId/invoices': typeof DashboardClientsClientIdInvoicesIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/payment': typeof PaymentRouteWithChildren
  '/': typeof DashboardIndexRoute
  '/blacklisting-requests/new': typeof DashboardBlacklistingRequestsNewRoute
  '/clients/create': typeof DashboardClientsCreateRoute
  '/continuous-payment-portout-requests/cancel': typeof DashboardContinuousPaymentPortoutRequestsCancelRoute
  '/continuous-payment-portout-requests/new': typeof DashboardContinuousPaymentPortoutRequestsNewRoute
  '/delivery-requests/create': typeof DashboardDeliveryRequestsCreateRoute
  '/portout-requests/cancel': typeof DashboardPortoutRequestsCancelRoute
  '/portout-requests/new': typeof DashboardPortoutRequestsNewRoute
  '/payment/card-register/$token': typeof PaymentCardRegisterTokenRoute
  '/billing-management': typeof DashboardBillingManagementIndexRoute
  '/billing': typeof DashboardBillingIndexRoute
  '/blacklisting-requests': typeof DashboardBlacklistingRequestsIndexRoute
  '/call-details': typeof DashboardCallDetailsIndexRoute
  '/clients': typeof DashboardClientsIndexRoute
  '/continuous-payment-confirmation': typeof DashboardContinuousPaymentConfirmationIndexRoute
  '/continuous-payment-portout-requests': typeof DashboardContinuousPaymentPortoutRequestsIndexRoute
  '/delivery-requests': typeof DashboardDeliveryRequestsIndexRoute
  '/ownership-transfer': typeof DashboardOwnershipTransferIndexRoute
  '/portout-requests': typeof DashboardPortoutRequestsIndexRoute
  '/search': typeof DashboardSearchIndexRoute
  '/clients/$clientId/sim-binding': typeof DashboardClientsClientIdSimBindingRoute
  '/delivery-requests/$id/shipping-history': typeof DashboardDeliveryRequestsIdShippingHistoryRoute
  '/clients/$clientId': typeof DashboardClientsClientIdIndexRoute
  '/clients/$clientId/invoices/$invoiceId': typeof DashboardClientsClientIdInvoicesInvoiceIdRoute
  '/clients/$clientId/invoices': typeof DashboardClientsClientIdInvoicesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_dashboard': typeof DashboardRouteWithChildren
  '/login': typeof LoginRoute
  '/payment': typeof PaymentRouteWithChildren
  '/_dashboard/': typeof DashboardIndexRoute
  '/_dashboard/blacklisting-requests/new': typeof DashboardBlacklistingRequestsNewRoute
  '/_dashboard/clients/create': typeof DashboardClientsCreateRoute
  '/_dashboard/continuous-payment-portout-requests/cancel': typeof DashboardContinuousPaymentPortoutRequestsCancelRoute
  '/_dashboard/continuous-payment-portout-requests/new': typeof DashboardContinuousPaymentPortoutRequestsNewRoute
  '/_dashboard/delivery-requests/create': typeof DashboardDeliveryRequestsCreateRoute
  '/_dashboard/portout-requests/cancel': typeof DashboardPortoutRequestsCancelRoute
  '/_dashboard/portout-requests/new': typeof DashboardPortoutRequestsNewRoute
  '/payment/card-register/$token': typeof PaymentCardRegisterTokenRoute
  '/_dashboard/billing-management/': typeof DashboardBillingManagementIndexRoute
  '/_dashboard/billing/': typeof DashboardBillingIndexRoute
  '/_dashboard/blacklisting-requests/': typeof DashboardBlacklistingRequestsIndexRoute
  '/_dashboard/call-details/': typeof DashboardCallDetailsIndexRoute
  '/_dashboard/clients/': typeof DashboardClientsIndexRoute
  '/_dashboard/continuous-payment-confirmation/': typeof DashboardContinuousPaymentConfirmationIndexRoute
  '/_dashboard/continuous-payment-portout-requests/': typeof DashboardContinuousPaymentPortoutRequestsIndexRoute
  '/_dashboard/delivery-requests/': typeof DashboardDeliveryRequestsIndexRoute
  '/_dashboard/ownership-transfer/': typeof DashboardOwnershipTransferIndexRoute
  '/_dashboard/portout-requests/': typeof DashboardPortoutRequestsIndexRoute
  '/_dashboard/search/': typeof DashboardSearchIndexRoute
  '/_dashboard/clients/$clientId/sim-binding': typeof DashboardClientsClientIdSimBindingRoute
  '/_dashboard/delivery-requests/$id/shipping-history': typeof DashboardDeliveryRequestsIdShippingHistoryRoute
  '/_dashboard/clients/$clientId/': typeof DashboardClientsClientIdIndexRoute
  '/_dashboard/clients/$clientId/invoices/$invoiceId': typeof DashboardClientsClientIdInvoicesInvoiceIdRoute
  '/_dashboard/clients/$clientId/invoices/': typeof DashboardClientsClientIdInvoicesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/login'
    | '/payment'
    | '/'
    | '/blacklisting-requests/new'
    | '/clients/create'
    | '/continuous-payment-portout-requests/cancel'
    | '/continuous-payment-portout-requests/new'
    | '/delivery-requests/create'
    | '/portout-requests/cancel'
    | '/portout-requests/new'
    | '/payment/card-register/$token'
    | '/billing-management'
    | '/billing'
    | '/blacklisting-requests'
    | '/call-details'
    | '/clients'
    | '/continuous-payment-confirmation'
    | '/continuous-payment-portout-requests'
    | '/delivery-requests'
    | '/ownership-transfer'
    | '/portout-requests'
    | '/search'
    | '/clients/$clientId/sim-binding'
    | '/delivery-requests/$id/shipping-history'
    | '/clients/$clientId'
    | '/clients/$clientId/invoices/$invoiceId'
    | '/clients/$clientId/invoices'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/payment'
    | '/'
    | '/blacklisting-requests/new'
    | '/clients/create'
    | '/continuous-payment-portout-requests/cancel'
    | '/continuous-payment-portout-requests/new'
    | '/delivery-requests/create'
    | '/portout-requests/cancel'
    | '/portout-requests/new'
    | '/payment/card-register/$token'
    | '/billing-management'
    | '/billing'
    | '/blacklisting-requests'
    | '/call-details'
    | '/clients'
    | '/continuous-payment-confirmation'
    | '/continuous-payment-portout-requests'
    | '/delivery-requests'
    | '/ownership-transfer'
    | '/portout-requests'
    | '/search'
    | '/clients/$clientId/sim-binding'
    | '/delivery-requests/$id/shipping-history'
    | '/clients/$clientId'
    | '/clients/$clientId/invoices/$invoiceId'
    | '/clients/$clientId/invoices'
  id:
    | '__root__'
    | '/_dashboard'
    | '/login'
    | '/payment'
    | '/_dashboard/'
    | '/_dashboard/blacklisting-requests/new'
    | '/_dashboard/clients/create'
    | '/_dashboard/continuous-payment-portout-requests/cancel'
    | '/_dashboard/continuous-payment-portout-requests/new'
    | '/_dashboard/delivery-requests/create'
    | '/_dashboard/portout-requests/cancel'
    | '/_dashboard/portout-requests/new'
    | '/payment/card-register/$token'
    | '/_dashboard/billing-management/'
    | '/_dashboard/billing/'
    | '/_dashboard/blacklisting-requests/'
    | '/_dashboard/call-details/'
    | '/_dashboard/clients/'
    | '/_dashboard/continuous-payment-confirmation/'
    | '/_dashboard/continuous-payment-portout-requests/'
    | '/_dashboard/delivery-requests/'
    | '/_dashboard/ownership-transfer/'
    | '/_dashboard/portout-requests/'
    | '/_dashboard/search/'
    | '/_dashboard/clients/$clientId/sim-binding'
    | '/_dashboard/delivery-requests/$id/shipping-history'
    | '/_dashboard/clients/$clientId/'
    | '/_dashboard/clients/$clientId/invoices/$invoiceId'
    | '/_dashboard/clients/$clientId/invoices/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  DashboardRoute: typeof DashboardRouteWithChildren
  LoginRoute: typeof LoginRoute
  PaymentRoute: typeof PaymentRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/payment': {
      id: '/payment'
      path: '/payment'
      fullPath: '/payment'
      preLoaderRoute: typeof PaymentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/': {
      id: '/_dashboard/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/search/': {
      id: '/_dashboard/search/'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof DashboardSearchIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/portout-requests/': {
      id: '/_dashboard/portout-requests/'
      path: '/portout-requests'
      fullPath: '/portout-requests'
      preLoaderRoute: typeof DashboardPortoutRequestsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/ownership-transfer/': {
      id: '/_dashboard/ownership-transfer/'
      path: '/ownership-transfer'
      fullPath: '/ownership-transfer'
      preLoaderRoute: typeof DashboardOwnershipTransferIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/delivery-requests/': {
      id: '/_dashboard/delivery-requests/'
      path: '/delivery-requests'
      fullPath: '/delivery-requests'
      preLoaderRoute: typeof DashboardDeliveryRequestsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/continuous-payment-portout-requests/': {
      id: '/_dashboard/continuous-payment-portout-requests/'
      path: '/continuous-payment-portout-requests'
      fullPath: '/continuous-payment-portout-requests'
      preLoaderRoute: typeof DashboardContinuousPaymentPortoutRequestsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/continuous-payment-confirmation/': {
      id: '/_dashboard/continuous-payment-confirmation/'
      path: '/continuous-payment-confirmation'
      fullPath: '/continuous-payment-confirmation'
      preLoaderRoute: typeof DashboardContinuousPaymentConfirmationIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/clients/': {
      id: '/_dashboard/clients/'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof DashboardClientsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/call-details/': {
      id: '/_dashboard/call-details/'
      path: '/call-details'
      fullPath: '/call-details'
      preLoaderRoute: typeof DashboardCallDetailsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/blacklisting-requests/': {
      id: '/_dashboard/blacklisting-requests/'
      path: '/blacklisting-requests'
      fullPath: '/blacklisting-requests'
      preLoaderRoute: typeof DashboardBlacklistingRequestsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/billing/': {
      id: '/_dashboard/billing/'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof DashboardBillingIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/billing-management/': {
      id: '/_dashboard/billing-management/'
      path: '/billing-management'
      fullPath: '/billing-management'
      preLoaderRoute: typeof DashboardBillingManagementIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/payment/card-register/$token': {
      id: '/payment/card-register/$token'
      path: '/card-register/$token'
      fullPath: '/payment/card-register/$token'
      preLoaderRoute: typeof PaymentCardRegisterTokenRouteImport
      parentRoute: typeof PaymentRoute
    }
    '/_dashboard/portout-requests/new': {
      id: '/_dashboard/portout-requests/new'
      path: '/portout-requests/new'
      fullPath: '/portout-requests/new'
      preLoaderRoute: typeof DashboardPortoutRequestsNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/portout-requests/cancel': {
      id: '/_dashboard/portout-requests/cancel'
      path: '/portout-requests/cancel'
      fullPath: '/portout-requests/cancel'
      preLoaderRoute: typeof DashboardPortoutRequestsCancelRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/delivery-requests/create': {
      id: '/_dashboard/delivery-requests/create'
      path: '/delivery-requests/create'
      fullPath: '/delivery-requests/create'
      preLoaderRoute: typeof DashboardDeliveryRequestsCreateRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/continuous-payment-portout-requests/new': {
      id: '/_dashboard/continuous-payment-portout-requests/new'
      path: '/continuous-payment-portout-requests/new'
      fullPath: '/continuous-payment-portout-requests/new'
      preLoaderRoute: typeof DashboardContinuousPaymentPortoutRequestsNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/continuous-payment-portout-requests/cancel': {
      id: '/_dashboard/continuous-payment-portout-requests/cancel'
      path: '/continuous-payment-portout-requests/cancel'
      fullPath: '/continuous-payment-portout-requests/cancel'
      preLoaderRoute: typeof DashboardContinuousPaymentPortoutRequestsCancelRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/clients/create': {
      id: '/_dashboard/clients/create'
      path: '/clients/create'
      fullPath: '/clients/create'
      preLoaderRoute: typeof DashboardClientsCreateRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/blacklisting-requests/new': {
      id: '/_dashboard/blacklisting-requests/new'
      path: '/blacklisting-requests/new'
      fullPath: '/blacklisting-requests/new'
      preLoaderRoute: typeof DashboardBlacklistingRequestsNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/clients/$clientId/': {
      id: '/_dashboard/clients/$clientId/'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof DashboardClientsClientIdIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/delivery-requests/$id/shipping-history': {
      id: '/_dashboard/delivery-requests/$id/shipping-history'
      path: '/delivery-requests/$id/shipping-history'
      fullPath: '/delivery-requests/$id/shipping-history'
      preLoaderRoute: typeof DashboardDeliveryRequestsIdShippingHistoryRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/clients/$clientId/sim-binding': {
      id: '/_dashboard/clients/$clientId/sim-binding'
      path: '/clients/$clientId/sim-binding'
      fullPath: '/clients/$clientId/sim-binding'
      preLoaderRoute: typeof DashboardClientsClientIdSimBindingRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/clients/$clientId/invoices/': {
      id: '/_dashboard/clients/$clientId/invoices/'
      path: '/clients/$clientId/invoices'
      fullPath: '/clients/$clientId/invoices'
      preLoaderRoute: typeof DashboardClientsClientIdInvoicesIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/clients/$clientId/invoices/$invoiceId': {
      id: '/_dashboard/clients/$clientId/invoices/$invoiceId'
      path: '/clients/$clientId/invoices/$invoiceId'
      fullPath: '/clients/$clientId/invoices/$invoiceId'
      preLoaderRoute: typeof DashboardClientsClientIdInvoicesInvoiceIdRouteImport
      parentRoute: typeof DashboardRoute
    }
  }
}

interface DashboardRouteChildren {
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardBlacklistingRequestsNewRoute: typeof DashboardBlacklistingRequestsNewRoute
  DashboardClientsCreateRoute: typeof DashboardClientsCreateRoute
  DashboardContinuousPaymentPortoutRequestsCancelRoute: typeof DashboardContinuousPaymentPortoutRequestsCancelRoute
  DashboardContinuousPaymentPortoutRequestsNewRoute: typeof DashboardContinuousPaymentPortoutRequestsNewRoute
  DashboardDeliveryRequestsCreateRoute: typeof DashboardDeliveryRequestsCreateRoute
  DashboardPortoutRequestsCancelRoute: typeof DashboardPortoutRequestsCancelRoute
  DashboardPortoutRequestsNewRoute: typeof DashboardPortoutRequestsNewRoute
  DashboardBillingManagementIndexRoute: typeof DashboardBillingManagementIndexRoute
  DashboardBillingIndexRoute: typeof DashboardBillingIndexRoute
  DashboardBlacklistingRequestsIndexRoute: typeof DashboardBlacklistingRequestsIndexRoute
  DashboardCallDetailsIndexRoute: typeof DashboardCallDetailsIndexRoute
  DashboardClientsIndexRoute: typeof DashboardClientsIndexRoute
  DashboardContinuousPaymentConfirmationIndexRoute: typeof DashboardContinuousPaymentConfirmationIndexRoute
  DashboardContinuousPaymentPortoutRequestsIndexRoute: typeof DashboardContinuousPaymentPortoutRequestsIndexRoute
  DashboardDeliveryRequestsIndexRoute: typeof DashboardDeliveryRequestsIndexRoute
  DashboardOwnershipTransferIndexRoute: typeof DashboardOwnershipTransferIndexRoute
  DashboardPortoutRequestsIndexRoute: typeof DashboardPortoutRequestsIndexRoute
  DashboardSearchIndexRoute: typeof DashboardSearchIndexRoute
  DashboardClientsClientIdSimBindingRoute: typeof DashboardClientsClientIdSimBindingRoute
  DashboardDeliveryRequestsIdShippingHistoryRoute: typeof DashboardDeliveryRequestsIdShippingHistoryRoute
  DashboardClientsClientIdIndexRoute: typeof DashboardClientsClientIdIndexRoute
  DashboardClientsClientIdInvoicesInvoiceIdRoute: typeof DashboardClientsClientIdInvoicesInvoiceIdRoute
  DashboardClientsClientIdInvoicesIndexRoute: typeof DashboardClientsClientIdInvoicesIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardBlacklistingRequestsNewRoute: DashboardBlacklistingRequestsNewRoute,
  DashboardClientsCreateRoute: DashboardClientsCreateRoute,
  DashboardContinuousPaymentPortoutRequestsCancelRoute:
    DashboardContinuousPaymentPortoutRequestsCancelRoute,
  DashboardContinuousPaymentPortoutRequestsNewRoute:
    DashboardContinuousPaymentPortoutRequestsNewRoute,
  DashboardDeliveryRequestsCreateRoute: DashboardDeliveryRequestsCreateRoute,
  DashboardPortoutRequestsCancelRoute: DashboardPortoutRequestsCancelRoute,
  DashboardPortoutRequestsNewRoute: DashboardPortoutRequestsNewRoute,
  DashboardBillingManagementIndexRoute: DashboardBillingManagementIndexRoute,
  DashboardBillingIndexRoute: DashboardBillingIndexRoute,
  DashboardBlacklistingRequestsIndexRoute:
    DashboardBlacklistingRequestsIndexRoute,
  DashboardCallDetailsIndexRoute: DashboardCallDetailsIndexRoute,
  DashboardClientsIndexRoute: DashboardClientsIndexRoute,
  DashboardContinuousPaymentConfirmationIndexRoute:
    DashboardContinuousPaymentConfirmationIndexRoute,
  DashboardContinuousPaymentPortoutRequestsIndexRoute:
    DashboardContinuousPaymentPortoutRequestsIndexRoute,
  DashboardDeliveryRequestsIndexRoute: DashboardDeliveryRequestsIndexRoute,
  DashboardOwnershipTransferIndexRoute: DashboardOwnershipTransferIndexRoute,
  DashboardPortoutRequestsIndexRoute: DashboardPortoutRequestsIndexRoute,
  DashboardSearchIndexRoute: DashboardSearchIndexRoute,
  DashboardClientsClientIdSimBindingRoute:
    DashboardClientsClientIdSimBindingRoute,
  DashboardDeliveryRequestsIdShippingHistoryRoute:
    DashboardDeliveryRequestsIdShippingHistoryRoute,
  DashboardClientsClientIdIndexRoute: DashboardClientsClientIdIndexRoute,
  DashboardClientsClientIdInvoicesInvoiceIdRoute:
    DashboardClientsClientIdInvoicesInvoiceIdRoute,
  DashboardClientsClientIdInvoicesIndexRoute:
    DashboardClientsClientIdInvoicesIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

interface PaymentRouteChildren {
  PaymentCardRegisterTokenRoute: typeof PaymentCardRegisterTokenRoute
}

const PaymentRouteChildren: PaymentRouteChildren = {
  PaymentCardRegisterTokenRoute: PaymentCardRegisterTokenRoute,
}

const PaymentRouteWithChildren =
  PaymentRoute._addFileChildren(PaymentRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  DashboardRoute: DashboardRouteWithChildren,
  LoginRoute: LoginRoute,
  PaymentRoute: PaymentRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
